import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Camera, Contact, Search, Settings, Lock } from "lucide-react";

export const BottomTabBar = ({ features }) => {
  const { pathname } = useLocation();
  const f = features || {};
  const tabs = [
    { path: "/dashboard", label: "Dashboard", Icon: LayoutDashboard },
    { path: "/pic-to-lead", label: "Pic-to-Lead", Icon: Camera },
    f.my_leads
      ? { path: "/my-leads", label: "My Leads", Icon: Contact }
      : { path: "/settings", label: "Settings", Icon: Settings },
    { path: "/discover", label: "Discover", Icon: Search, locked: features && !f.discover },
  ];

  return (
    <nav className="bottom-tab-bar" data-testid="bottom-tab-bar">
      {tabs.map(({ path, label, Icon, locked }) => {
        const active = pathname === path || pathname.startsWith(`${path}/`);
        return (
          <Link key={path} to={path} className={`bottom-tab ${active ? "active" : ""} ${locked ? "locked" : ""}`}
            data-testid={`bottom-tab-${path.slice(1)}`} aria-current={active ? "page" : undefined}>
            <span style={{ position: "relative", display: "inline-flex" }}>
              <Icon size={22} strokeWidth={active ? 2.4 : 1.8} />
              {locked && <Lock size={11} className="bottom-tab-lock" />}
            </span>
            <span>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
};
